var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoResults = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 193 145"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M61 27h42l20 19.5V107a5 5 0 0 1-5 5H61a5 5 0 0 1-5-5V32a5 5 0 0 1 5-5z",
  id: "a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 0h42l20 19.5V80a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5z",
  id: "b"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 20.5l.644-.104a6.894 6.894 0 0 0 5.659-5.43L7.5 14l.096.63a6.894 6.894 0 0 0 5.774 5.774l.63.096-.966.197a6.894 6.894 0 0 0-5.43 5.66L7.5 27l-.213-.993a6.894 6.894 0 0 0-5.294-5.294L1 20.5zM13 31l.495-.08a5.303 5.303 0 0 0 4.353-4.177L18 26l.074.485a5.303 5.303 0 0 0 4.441 4.44L23 31l-.743.152a5.303 5.303 0 0 0-4.177 4.353L18 36l-.164-.764a5.303 5.303 0 0 0-4.072-4.072L13 31z",
  fill: "#D8D8D8"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#E4E4E4",
  cx: 96.5,
  cy: 141,
  rx: 49.5,
  ry: 4
}), /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#F8F8F8",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#A7A9AC",
  strokeWidth: 3,
  d: "M61 25.5h42.61l20.89 20.368V107a6.5 6.5 0 0 1-6.5 6.5H61a6.5 6.5 0 0 1-6.5-6.5V32a6.5 6.5 0 0 1 6.5-6.5z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M70 16h42l20 19.5V96a5 5 0 0 1-5 5H74a9 9 0 0 1-9-9V21a5 5 0 0 1 5-5z",
  fill: "#A7A9AC",
  opacity: 0.099
}), /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(71 10)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#F8F8F8",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#A7A9AC",
  strokeWidth: 3,
  d: "M5-1.5h42.61L68.5 18.868V80a6.5 6.5 0 0 1-6.5 6.5H5A6.5 6.5 0 0 1-1.5 80V5A6.5 6.5 0 0 1 5-1.5z"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#A7A9AC",
  strokeWidth: 3,
  d: "M118 10v20.006h21.094"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#A7A9AC",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M97.603 46.138L81.118 74.481A7 7 0 0 0 87.17 85h33.838a7 7 0 0 0 5.97-10.655l-17.353-28.342a7 7 0 0 0-12.02.135z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M104 58v10.5M104 75v.5"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M165 55.659v8.294a1 1 0 0 0 1.467.884l7.857-4.147a1 1 0 0 0 0-1.769l-7.857-4.147a1 1 0 0 0-1.467.885z",
  fill: "#D8D8D8"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#E4E4E4",
  strokeWidth: 2,
  cx: 187.5,
  cy: 74.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#E5E5E5",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M169.5 7.5v12M175.5 13.5h-12"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#E5E5E5",
  strokeLinecap: "round",
  strokeWidth: 1.08
}, /*#__PURE__*/React.createElement("path", {
  d: "M182.129 1.129l4.242 4.242M186.371 1.129L182.13 5.37"
})), /*#__PURE__*/React.createElement("circle", {
  fill: "#E4E4E4",
  cx: 25,
  cy: 66,
  r: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.447 84.224l5 2.5a1 1 0 0 1 .553.894v5.808a1 1 0 0 1-.496.863l-5 2.917a1 1 0 0 1-1.008 0l-5-2.917A1 1 0 0 1 0 93.426v-5.808a1 1 0 0 1 .553-.894l5-2.5a1 1 0 0 1 .894 0z",
  fill: "#D8D8D8"
}))));
export default SvgNoResults;